"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketCounter = void 0;
var BasketCounter = /** @class */ (function () {
    function BasketCounter() {
        // Using a list because we have separate layout elements for mobile and desktop
        this.counters = document.querySelectorAll('.js-header-cart-total');
    }
    BasketCounter.prototype.update = function (count) {
        if (this.counters) {
            // innerHTML expects a string
            this.counters.forEach(function (counter) { return (counter.innerHTML = "".concat(count)); });
        }
    };
    return BasketCounter;
}());
exports.BasketCounter = BasketCounter;
